import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageVirtualConnectionTableActive = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={24}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M11.5 21a1.5 1.5 0 0 1-1.374-.898l-.04-.101L6 20v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V17H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-7v1.086c.436.154.778.502.924.941l-.01-.028L18 19v1h-5.086l.008-.022A1.5 1.5 0 0 1 11.5 21Zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM5 16h4v-2H5v2Zm9 0v-2h-4v2h4Zm5 0v-2h-4v2h4Zm0-3v-2h-4v2h4ZM5 13h4v-2H5v2Zm9-2h-4v2h4v-2ZM5 8v2h4V8H5Zm14-3H5v2h14V5Zm-4 5h4V8h-4v2Zm-5-2v2h4V8h-4Z"
      fill="#333"
      fillRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageVirtualConnectionTableActive);
export default Memo;
